import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { RecurringOrdersState, RecurringOrdersContextActionTypes } from './types';
import { defaultState } from './defaultState';

const RecurringOrdersContext = createContext<Partial<RecurringOrdersState>>(defaultState);
const RecurringOrdersDispatchContext = createContext<
  Dispatch<PayloadAction<RecurringOrdersContextActionTypes, any>> | undefined
>(undefined);

export { RecurringOrdersContext, RecurringOrdersDispatchContext };
